import React from 'react';
import {FlatDomainDataContext, FormBean, IBillerDef, IUIComponentDef} from '../../../app/datatypes';

export interface DomainAttrInUIComponentProps {
    objectName:string,
    name:string,
    domainDataType:string|null,
    namePrefix:string, // e.g 
 };

export interface BaseUIComponentProps {
    metadata:IUIComponentDef;
    ctx:FlatDomainDataContext; 
    formBean:FormBean;
    cId?:string;
    dataGridField?:boolean;
    error?: any;
    domainAttribute?: DomainAttrInUIComponentProps;
};

export abstract class BaseUIComponent<P extends BaseUIComponentProps> extends React.Component<P, {}> {
    constructor(props: P){
        super(props);
    }
} 

/** substibute biller attribute in text */
export function replaceBillerInfo(text:string, billerInfo:IBillerDef){
    let regexBiller = /{.*?}/g;
    let allBillerText = text ? text.match(regexBiller) : null;
    
    if (allBillerText) {
      allBillerText.map(innerText => {
        let attrValue = innerText.replace(/[{}.]|Biller/g,"");
        // @ts-ignore todo: check invalid attr!
        text = text.replace(innerText, billerInfo[attrValue] || "")
      });
    }
    return text;
}
